"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Outcodes = void 0;
const outcodesGetOutcodeLocationOutcodesOutcodeLocationGet_js_1 = require("../funcs/outcodesGetOutcodeLocationOutcodesOutcodeLocationGet.js");
const outcodesGetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGet_js_1 = require("../funcs/outcodesGetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGet.js");
const outcodesGetOutcodePostcodeLocationOutcodesOutcodeSectorsGet_js_1 = require("../funcs/outcodesGetOutcodePostcodeLocationOutcodesOutcodeSectorsGet.js");
const sdks_js_1 = require("../lib/sdks.js");
const fp_js_1 = require("./types/fp.js");
class Outcodes extends sdks_js_1.ClientSDK {
    /**
     * Get Outcode Location
     *
     * @remarks
     * Get location data for an outcode.
     */
    async getOutcodeLocationOutcodesOutcodeLocationGet(security, outcode, options) {
        return (0, fp_js_1.unwrapAsync)((0, outcodesGetOutcodeLocationOutcodesOutcodeLocationGet_js_1.outcodesGetOutcodeLocationOutcodesOutcodeLocationGet)(this, security, outcode, options));
    }
    /**
     * Get Outcode Postcode Location
     *
     * @remarks
     * Get postcode location data for postcodes inside of an outcode.
     */
    async getOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGet(security, outcode, options) {
        return (0, fp_js_1.unwrapAsync)((0, outcodesGetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGet_js_1.outcodesGetOutcodePostcodeLocationOutcodesOutcodePostcodeLocationGet)(this, security, outcode, options));
    }
    /**
     * Get Outcode Postcode Location
     *
     * @remarks
     * Get sectors inside of an outcode.
     */
    async getOutcodePostcodeLocationOutcodesOutcodeSectorsGet(security, outcode, options) {
        return (0, fp_js_1.unwrapAsync)((0, outcodesGetOutcodePostcodeLocationOutcodesOutcodeSectorsGet_js_1.outcodesGetOutcodePostcodeLocationOutcodesOutcodeSectorsGet)(this, security, outcode, options));
    }
}
exports.Outcodes = Outcodes;
//# sourceMappingURL=outcodes.js.map